// overlay_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static get targets() {
    return ["loadingOverlay"];
  }
  static get values() {
    return { count: Number };
  }

  connect() {
    this.countValue = 0;
    this.hideOverlay();
    this.bindEvents();
  }

  bindEvents() {
    this.showOverlayHandler = this.showOverlay.bind(this);
    this.hideOverlayHandler = this.hideOverlay.bind(this);

    document.addEventListener("overlay:show", this.showOverlayHandler);
    document.addEventListener("overlay:hide", this.hideOverlayHandler);
  }

  disconnect() {
    document.removeEventListener("overlay:show", this.showOverlayHandler);
    document.removeEventListener("overlay:hide", this.hideOverlayHandler);
  }

  showOverlay() {
    this.countValue++;
    this.updateOverlayVisibility();
  }

  hideOverlay() {
    if (this.countValue > 0) {
      this.countValue--;
    }
    this.updateOverlayVisibility();
  }

  updateOverlayVisibility() {
    if (this.countValue > 0) {
      this.loadingOverlayTarget.classList.add("df");
    } else {
      this.loadingOverlayTarget.classList.remove("df");
    }
  }
}
